'use client'
import { useState } from 'react'
import { Container, NavPill, Overlay, Spacer } from '@/src/ct-design/lib'
import { getBrandLogo } from '@/src/constants/buildVariant'
import { Brand } from '@/src/utils/brand'
import { getSupportUrl } from '@/src/utils/helper'
import UserProfile from '../navbar/userProfile'

type NavBarVariant = 'FW' | 'NW'

interface NavBarProps {
    brand: Brand
    variant?: NavBarVariant
}

const NavBar = ({ brand, variant = 'NW' }: NavBarProps) => {
    const [showUserMenu, setShowUserMenu] = useState<boolean>(false)
    const BrandLogo = getBrandLogo(brand)
    const useFullWidth = variant === 'FW'

    const containerClassName = useFullWidth
        ? 'flex flex-between flex-middle py-2 mx-9'
        : 'flex flex-between flex-middle container py-2'

    return (
        <>
            <Container className='z-40 bg-neutral-100 p-relative'>
                <Container className={containerClassName}>
                    <Container
                        className='c-pointer'
                        onClick={() => (window.location.href = '/')}
                    >
                        <BrandLogo />
                    </Container>
                    <Container className='flex'>
                        <NavPill
                            onClick={() => window.open(getSupportUrl(brand), '_blank')}
                            showIcon={true}
                            type='support'
                            displayValue='Support'
                        />
                        <Spacer className='mr-2' />
                        <UserProfile
                            brand={brand}
                            showUserMenu={showUserMenu}
                            setShowUserMenu={setShowUserMenu}
                        />
                    </Container>
                </Container>
            </Container>
            {showUserMenu && (
                <Overlay
                    customStyle={{
                        background: 'rgba(26, 26, 26, 0.4)',
                        zIndex: '30'
                    }}
                />
            )}
        </>
    )
}

export default NavBar
